import { render } from "./FHIRpage.vue?vue&type=template&id=5a0994b1"
import script from "./FHIRpage.js?vue&type=script&lang=js"
export * from "./FHIRpage.js?vue&type=script&lang=js"

import "./FHIRpage.vue?vue&type=style&index=0&id=5a0994b1&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__